import { Alert, Text, TextField } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { DELETE_CONFIRMATION_WORD } from "@utils/plan-actions-utils";

interface Props {
  /** What the user typed to confirm the deletion */
  confirmationText: string;

  /** Called with the new text when the user types */
  onConfirmationTextChange(text: string): void;
}

/**
 * Warns that deleting plans can't be undone and lets the user confirm it by typing the
 * confirmation word, so that a plan is never deleted by a single misplaced click.
 */
export function DeletePlanConfirmation({
  confirmationText,
  onConfirmationTextChange,
}: Props): React.JSX.Element {
  return (
    <>
      <Alert
        variant="error"
        title="Plans deleted are removed completely from the workspace along with all of their comments"
        description="Please consider keeping them deactivated instead."
        sx={{ my: 2 }}
      />
      <Text variant="bodyL">
        To confirm, type{" "}
        <Box component="b" sx={{ color: "error.main" }}>
          {DELETE_CONFIRMATION_WORD}
        </Box>{" "}
        below:
      </Text>
      <TextField
        variant="outlined"
        placeholder={DELETE_CONFIRMATION_WORD}
        text={confirmationText}
        onTextChanged={onConfirmationTextChange}
        fullWidth
        controlStyle={{ mt: 1 }}
      />
    </>
  );
}
